import { Img, Text } from 'components'
import React, { useCallback, useMemo, useState } from 'react'

const TableLogPoolReplacements = ({ data }) => {
  const [sortDir, setSortDir] = useState('asc')
  const [sortCol, setSortCol] = useState('')

  const _handleSort = useCallback((col) => {
    if (col === sortCol) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc')
    } else {
      setSortCol(col)
      setSortDir('desc')
    }
  }, [sortCol, sortDir])

  const _headCol = useCallback((content, _sortCol) => {
    return (
      <div className='w-[25%] flex items-center gap-1'>
        <Text as="p" className="!font-bold !text-blue_gray-200 tracking-[-0.14px] ">
          {content}
        </Text>
        {
          _sortCol ?
            <Img
              onClick={() => _handleSort(_sortCol)}
              src='images/img_arrow_down.svg'
              className={`${sortDir === 'asc' && sortCol === _sortCol && '!rotate-180'}`}
            />
            : null
        }
      </div>
    )
  }, [sortDir, sortCol, setSortCol, setSortDir])

  const _getItemInfo = useCallback(({ previous_data, updated_data }) => {
    let prevFinancingNo = [],
      prevFinancingAmount = 0,
      updatedFinancingNo = [],
      updatedFinancingAmount = 0

    if (previous_data && previous_data.length)
      for (let i = 0; i < previous_data.length; i++) {
        prevFinancingNo[i] = previous_data[i].financing_no
        prevFinancingAmount += previous_data[i].financing_amount
      }

    if (updated_data && updated_data.length)
      for (let i = 0; i < updated_data.length; i++) {
        updatedFinancingNo[i] = updated_data[i].financing_no
        updatedFinancingAmount += updated_data[i].financing_amount
      }

    return {
      prevFinancingNo: prevFinancingNo.join(', '),
      prevFinancingAmount,
      updatedFinancingNo: updatedFinancingNo.join(', '),
      updatedFinancingAmount
    }
  }, [])

  const _col = useCallback((content) => {
    return (
      <div className='w-[25%] flex'>
        <Text as="p" className="!text-blue_gray-900_06 tracking-[-0.14px]">
          {content.toString().split(', ').map(c => (<>{c}<br /></>))}
        </Text>
      </div>
    )
  }, [])

  const _row = useCallback((item, index) => {
    const {
      prevFinancingNo,
      prevFinancingAmount,
      updatedFinancingNo,
      updatedFinancingAmount
    } = item

    return (
      <div key={index} className="flex items-center justify-center w-full hover:bg-gray-50_02 py-5 gap-1">
        {_col(prevFinancingNo)}
        {_col(updatedFinancingNo)}
        {_col(prevFinancingAmount)}
        {_col(updatedFinancingAmount)}
      </div>
    )
  }, [_col])

  const _parsedData = useMemo(() => {
    return data.flatMap(i => i.redeem_histories).map(_getItemInfo)
  }, [data, _getItemInfo])

  const _sortedData = useMemo(() => {
    if (sortCol) {
      return [..._parsedData].sort((a, b) => {
        let aValue = a[sortCol]
        let bValue = b[sortCol]
        if (aValue < bValue) {
          return sortDir === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortDir === 'asc' ? 1 : -1;
        }
        return 0
      })
    }

    return _parsedData
  }, [_parsedData, sortDir, sortCol])

  return (
    <div className='w-full p-10 flex flex-col gap-10'>
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-center w-full pb-5">
          {_headCol('Previous Financing No')}
          {_headCol('Updated Financing No')}
          {_headCol('Previous Financing Amount', 'prevFinancingAmount')}
          {_headCol('Updated Financing No', 'updatedFinancingAmount')}
        </div>
        <div className='h-px bg-orange-100 w-full'></div>
        <div className="flex flex-col items-center justify-start w-full pb-10">
          {_sortedData.map(_row)}
        </div>
      </div>
    </div>
  )
}

export default React.memo(TableLogPoolReplacements)